import { Box, SimpleGrid } from "@chakra-ui/react"
import { Feature } from "./feature"
import { FeaturesList } from "./features-list"

export const FeaturesComponent = () => {
  const renderFeatureList = () => {
    return FeaturesList.map((feature) => <Feature {...feature} />)
  }

  return (
    <Box p={4}>
      <SimpleGrid columns={{ base: 1, md: 3 }} p={"6"} spacing={10}>
        {renderFeatureList()}
      </SimpleGrid>
    </Box>
  )
}
